<template>
    <div id="deeplink">
        <div class="row" v-if="os!=null">
                <div class="col-12" style="margin-top: 40%; padding: 30px;">
                    <center>
                        <h3>Загрузите приложение для {{os}} по кнопке</h3>
                    </center>
                </div>
            </div>
            <div class="col-xs-12" style="padding: 3px;">
                <div class="row">
                    <div class="col-12" style="margin-top: 20px;">
                        <center>
                            <a :href="href" class="btn btn-lg btn-info">Установить приложение</a>
                        </center>
                    </div>
                </div>


            </div>
        </div>
</template>

<script>

  function getMobileOperatingSystem () {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera

    // Windows Phone must come first because its UA also contains "Android"
    // if (/windows phone/i.test(userAgent)) {
    //   return 'Windows Phone'
    // }

    if (/android/i.test(userAgent)) {
      return 'Android'
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'iOS'
    }

    return 'unknown'
  }

  export default {
    name: 'Deeplin',
    data () {
      return {
        os: null,
        href: '#'
      }
    },
    mounted () {
      this.os = getMobileOperatingSystem()
      this.setHref()
    },
    methods: {
      setHref () {
        if (this.os === 'iOS') {
          window.location = 'aki-webzakaz://https://1.aki1.ru/#/?id=1664&rc=wSha4F2b2J5N&client=172&magazin=0&contract=685&firm=1&stock=1&pricelist=1&agent=1&assortment=1&inn=&phone=&address='
          this.href = 'https://apps.apple.com/ru/app/id1482629784'
        }
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/UIComponents/Custom/Deeplink.vue